import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Transition from 'react-transition-group/Transition';

import Tabs from './Tabs';
import TabButtons from './TabButtons';
import ButtonArrowed from '../../widgets/Buttons/ButtonArrowed';

import './tab-content.scss';

const duration = 250;

class TextContent extends PureComponent {
  constructor(...props) {
    super(...props);

    this.state = {
      activeIndex: this.props.activeIndex,
      animate: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { activeIndex } = nextProps;

    if (this.state.activeIndex !== activeIndex) {
      this.setState({ animate: true });

      setTimeout(() => {
        this.setState({ activeIndex, animate: false });
      }, duration);
    }
  }

  render() {
    const tab = this.props.activeTab;

    return (
      <div className="text-content-container">
        <Transition in={this.state.animate} timeout={duration}>
          {status =>
            <div className={cn('text-content', status)}>
              <h2 dangerouslySetInnerHTML={{ __html: tab.title }} />

              <h4 dangerouslySetInnerHTML={{ __html: tab.description }} />
            </div>
          }
        </Transition>

        {(!this.props.isMobile) &&
          <ButtonArrowed
            link={`${tab.pathname}subnavigation/`}
            direction="right"
          >
            Подробнее
          </ButtonArrowed>
        }
      </div>
    );
  }
}

TextContent.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  activeTab: PropTypes.object.isRequired
};

class TabContent extends PureComponent {
  render() {
    const className = cn('tab-content', {
      'show-content': this.props.showTabContent
    });

    return (
      <div className={className}>
        <div className="background-gradient" />

        <div className="container">
          {(this.props.showTabContent) &&
            <div className="tab-content-container">
              <TextContent
                activeIndex={this.props.activeTabIndex}
                activeTab={this.props.activeTab}
                isMobile={this.props.isMobile}
              />

              <TabButtons
                onSubscribeClick={this.props.onSubscribeClick}
              />
            </div>
          }

          <Tabs
            tabs={this.props.navigationTabs}
            activeIndex={this.props.activeTabIndex}
            subnavigationPage={this.props.subnavigationPage}
            isMobile={this.props.isMobile}
          />
        </div>
      </div>
    );
  }
}

TabContent.propTypes = {
  activeTabIndex: PropTypes.number.isRequired,
  activeTab: PropTypes.object,
  navigationTabs: PropTypes.arrayOf(PropTypes.object).isRequired,
  showTabContent: PropTypes.bool,
  subnavigationPage: PropTypes.bool,
  infoData: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
  onSubscribeClick: PropTypes.func
};

export default TabContent;



// WEBPACK FOOTER //
// ./src/components/Layout/Subnavigation/TabContent.js